<template>
  <div class="zhanwei4"></div>
  <h1 class="title">时间积分</h1>
  <el-form
    :model="form"
    label-width="auto"
    label-position="top"
    style="max-width: 1000px; margin-left: 20px"
  >
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item label="游戏标准时长（分钟）">
          <el-input type="number" clearable v-model="form.gameTime" disabled />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="超时扣分">
          <el-input type="number" clearable v-model="form.timeoutDeducted" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item label="满分">
          <el-input type="number" clearable v-model="form.fullMarks" />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="多长时间内过关满分（分钟）">
          <el-input type="number" clearable v-model="form.parlayTime" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item label="关卡积分">
          <el-input type="number" clearable v-model="form.levelPoints" />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="每次答错积分">
          <el-input type="number" clearable v-model="form.incorrectAnswer" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item label="关卡数量">
          <el-input
            type="number"
            clearable
            v-model="form.numberLevel"
            disabled
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="使用提示扣分">
          <el-input type="number" clearable v-model="form.promptsDeduct" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item label="跳过过关扣分">
          <el-input type="number" clearable v-model="form.skippingParlay" />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="使用地点求救扣分">
          <el-input type="number" clearable v-model="form.sosPoints" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :xs="24">
        <p>游戏最高得分</p>
      </el-col>
      <el-col :xs="24"
        ><p>时间分数(满分) + 关卡积分 * 关卡数=游戏最高得分</p></el-col
      >
      <el-col :xs="24"
        ><p>
          {{ form.fullMarks }} + {{ form.numberLevel }} x
          {{ form.levelPoints }} =
          <span style="color: red">{{ totalPoint }}</span>
        </p></el-col
      >
      <el-col :xs="24"
        ><el-button
          style="background: #4f4f4f; color: #fff; margin-top: 20px"
          size="large"
          @click="saveSettings"
          >保存</el-button
        ></el-col
      >
    </el-row>
  </el-form>
  <div class="zhanwei3"></div>
</template>

<script lang="ts">
import { ElMessage, ElMessageBox } from "element-plus";
import { defineComponent } from "vue";
import vueQr from "vue-qr/src/packages/vue-qr.vue";

export default defineComponent({
  name: "release",
  data(): any {
    return {
      option: "",
      gameId: "",
      form: {
        id: "",
        gameTime: 0,
        timeoutDeducted: 0,
        parlayTime: 0,
        fullMarks: 0,
        levelPoints: 0,
        incorrectAnswer: 0,
        numberLevel: 0,
        promptsDeduct: 0,
        skippingParlay: 0,
        sosPoints: 0,
      },
      qr_text: "123",
    };
  },
  components: {
    vueQr,
  },
  computed: {
    totalPoint() {
      return (
        parseInt(this.form.fullMarks) +
        this.form.numberLevel * this.form.levelPoints
      );
    },
  },
  watch: {},
  mounted() {
    const { id, detailId } = this.$route.params;
    this.gameId = id;
    this.initRelease(id);
  },
  methods: {
    initRelease(id: string) {
      this.$store
        .dispatch("game/getBonus", { gameId: id })
        .then((res: any) => {
          this.form = res;
          console.log(res);
        })
        .catch((err: any) => {
          console.log(err);
        });
    },
    saveSettings() {
      this.$store
        .dispatch("game/updateBonus", { integralBean: this.form })
        .then((res: any) => {
          console.log(res);
        })
        .catch((err: any) => {
          console.log(err);
        });
    },
  },
});
</script>

<style lang="less" scoped>
.title {
  margin-left: 20px;
  margin-top: 10px;
}
p {
  margin-top: 20px;
}
</style>
